// downloadRecoveryCodes.ts — Builds a plain-text export of a freshly-generated 2FA recovery
// code set and triggers a client-side download. Mirrors downloadAccountData.ts's blob/anchor
// pattern (create → append → click → remove → revoke, so the object URL is never leaked).
// Contents are the codes only — never pass the TOTP secret or the member's password in here;
// each recovery code is single-use and stands in for a code from the authenticator app.
const HEADER = [
  'TruXSocial: Two-Factor Authentication Recovery Codes',
  '',
  'Each code below can be used once, in place of a 6-digit code from your',
  'authenticator app, if you ever lose access to it. A code stops working',
  'once it has been used.',
  '',
  'Keep this file somewhere safe and private.',
  '',
].join('\n');

/** Plain-text contents of the recovery-codes download — header + one code per line. */
export function buildRecoveryCodesText(codes: readonly string[], accountHandle = ''): string {
  const account = accountHandle.replace(/[\r\n]/g, '');
  return `${HEADER}${account ? `Account: ${account}\n\n` : ''}${codes.join('\n')}\n`;
}

/** Trigger a browser download of the recovery codes as a .txt file. */
export function downloadRecoveryCodes(codes: readonly string[], accountHandle = ''): void {
  const text = buildRecoveryCodesText(codes, accountHandle);
  const blob = new Blob([text], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  const account = accountHandle.replace(/^@/, '').replace(/[^a-zA-Z0-9_-]/g, '');
  a.download = `truxsocial${account ? `-${account}` : ''}-recovery-codes.txt`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
